__turbopack_context__.v({
  "card": "marketplace-module__uBacRW__card",
  "cardBody": "marketplace-module__uBacRW__cardBody",
  "carouselControls": "marketplace-module__uBacRW__carouselControls",
  "categoryChip": "marketplace-module__uBacRW__categoryChip",
  "categoryChipActive": "marketplace-module__uBacRW__categoryChipActive",
  "categoryChips": "marketplace-module__uBacRW__categoryChips",
  "categoryFilters": "marketplace-module__uBacRW__categoryFilters",
  "categoryLabel": "marketplace-module__uBacRW__categoryLabel",
  "company": "marketplace-module__uBacRW__company",
  "content": "marketplace-module__uBacRW__content",
  "count": "marketplace-module__uBacRW__count",
  "eyebrow": "marketplace-module__uBacRW__eyebrow",
  "favoriteVisual": "marketplace-module__uBacRW__favoriteVisual",
  "filter": "marketplace-module__uBacRW__filter",
  "filterActive": "marketplace-module__uBacRW__filterActive",
  "filterCount": "marketplace-module__uBacRW__filterCount",
  "filterDialog": "marketplace-module__uBacRW__filterDialog",
  "filterPanelGrid": "marketplace-module__uBacRW__filterPanelGrid",
  "filterPanelHeading": "marketplace-module__uBacRW__filterPanelHeading",
  "filterResultsHeader": "marketplace-module__uBacRW__filterResultsHeader",
  "filterTextQuery": "marketplace-module__uBacRW__filterTextQuery",
  "filterToggle": "marketplace-module__uBacRW__filterToggle",
  "filterToggleLabel": "marketplace-module__uBacRW__filterToggleLabel",
  "filters": "marketplace-module__uBacRW__filters",
  "grid": "marketplace-module__uBacRW__grid",
  "hero": "marketplace-module__uBacRW__hero",
  "heroInner": "marketplace-module__uBacRW__heroInner",
  "imagePlaceholder": "marketplace-module__uBacRW__imagePlaceholder",
  "imageWrap": "marketplace-module__uBacRW__imageWrap",
  "location": "marketplace-module__uBacRW__location",
  "marketSection": "marketplace-module__uBacRW__marketSection",
  "novidadeBadge": "marketplace-module__uBacRW__novidadeBadge",
  "novidadeBody": "marketplace-module__uBacRW__novidadeBody",
  "novidadeCard": "marketplace-module__uBacRW__novidadeCard",
  "novidadeCompany": "marketplace-module__uBacRW__novidadeCompany",
  "novidadeImage": "marketplace-module__uBacRW__novidadeImage",
  "novidadeLocation": "marketplace-module__uBacRW__novidadeLocation",
  "novidadeType": "marketplace-module__uBacRW__novidadeType",
  "novidadesCarousel": "marketplace-module__uBacRW__novidadesCarousel",
  "novidadesEyebrow": "marketplace-module__uBacRW__novidadesEyebrow",
  "novidadesHeader": "marketplace-module__uBacRW__novidadesHeader",
  "novidadesSection": "marketplace-module__uBacRW__novidadesSection",
  "page": "marketplace-module__uBacRW__page",
  "price": "marketplace-module__uBacRW__price",
  "realEstateHome": "marketplace-module__uBacRW__realEstateHome",
  "realEstateQuery": "marketplace-module__uBacRW__realEstateQuery",
  "realEstateRegionCard": "marketplace-module__uBacRW__realEstateRegionCard",
  "realEstateRegionContent": "marketplace-module__uBacRW__realEstateRegionContent",
  "realEstateRegionFallback": "marketplace-module__uBacRW__realEstateRegionFallback",
  "realEstateRegionOverlay": "marketplace-module__uBacRW__realEstateRegionOverlay",
  "realEstateRegionTrack": "marketplace-module__uBacRW__realEstateRegionTrack",
  "realEstateRegions": "marketplace-module__uBacRW__realEstateRegions",
  "realEstateSearch": "marketplace-module__uBacRW__realEstateSearch",
  "realEstateSearchFooter": "marketplace-module__uBacRW__realEstateSearchFooter",
  "realEstateSearchGrid": "marketplace-module__uBacRW__realEstateSearchGrid",
  "realEstateSearchHeading": "marketplace-module__uBacRW__realEstateSearchHeading",
  "realEstateTransaction": "marketplace-module__uBacRW__realEstateTransaction",
  "realEstateTransactionActive": "marketplace-module__uBacRW__realEstateTransactionActive",
  "realEstateTransactions": "marketplace-module__uBacRW__realEstateTransactions",
  "reference": "marketplace-module__uBacRW__reference",
  "resultEyebrow": "marketplace-module__uBacRW__resultEyebrow",
  "resultHeader": "marketplace-module__uBacRW__resultHeader",
  "sectionHeader": "marketplace-module__uBacRW__sectionHeader",
  "sections": "marketplace-module__uBacRW__sections",
  "seeAll": "marketplace-module__uBacRW__seeAll",
  "spin": "marketplace-module__uBacRW__spin",
  "spinner": "marketplace-module__uBacRW__spinner",
  "state": "marketplace-module__uBacRW__state",
  "typeBadge": "marketplace-module__uBacRW__typeBadge",
  "vehicleBrandCard": "marketplace-module__uBacRW__vehicleBrandCard",
  "vehicleBrandContent": "marketplace-module__uBacRW__vehicleBrandContent",
  "vehicleBrandFallback": "marketplace-module__uBacRW__vehicleBrandFallback",
  "vehicleBrandOverlay": "marketplace-module__uBacRW__vehicleBrandOverlay",
  "vehicleBrandTrack": "marketplace-module__uBacRW__vehicleBrandTrack",
  "vehicleBrands": "marketplace-module__uBacRW__vehicleBrands",
  "vehicleMarketplaceHome": "marketplace-module__uBacRW__vehicleMarketplaceHome",
  "vehicleQueryField": "marketplace-module__uBacRW__vehicleQueryField",
  "vehicleSearchFooter": "marketplace-module__uBacRW__vehicleSearchFooter",
  "vehicleSearchGrid": "marketplace-module__uBacRW__vehicleSearchGrid",
  "vehicleSearchHeading": "marketplace-module__uBacRW__vehicleSearchHeading",
  "vehicleSearchPanel": "marketplace-module__uBacRW__vehicleSearchPanel",
  "verified": "marketplace-module__uBacRW__verified",
});
